import { Component, Input, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { formatDistance } from 'date-fns';
import { TaskViewModel } from '../../models-views/task.view.model';
import { AppCommon } from '../../providers/app-common';
import { QuickAddService } from '../../services/quick-add.service';
import { ConsoleViewModel } from '../../models-views/console.view.modal';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ConsoleTabService } from '../../services/console-tab.service';
import { Task } from '../../models/task.model';
import { QuillCustomServices } from '../../providers/quill-config';

@Component({
  selector: 'app-console-task-tab',
  standalone: false,
  templateUrl: './console-task-tab.component.html',
  styleUrl: './console-task-tab.component.scss'
})
export class ConsoleTaskTabComponent {
  page: number = 1;
  page_size: number = 10;
  @Input() tabData: any;
  @Input() showTaskHeader: boolean;
  private destroy$ = new Subject<boolean>();
  taskData: Task;
  taskDataModel = new BehaviorSubject<Task>(undefined);
  is_reviewed: boolean = false;
  quillConfig:any
  listOfTaskStatus: any
  listOfPriority: any = []
  taskCommentList: any = []
  selectedAprovalModel: number = 1;
  COST_APPROVAL_STATUSES = [
    { id: 1, name: 'Not-Initiated', disabled: false },
    { id: 2, name: 'Initiate', disabled: false },
    { id: 3, name: 'Approved', disabled: true },
    { id: 4, name: 'Rejected', disabled: true }
  ]
  @ViewChild('commentsContainer') commentsContainer: ElementRef;
  loggedInUser: any
  newComment = '';
  selectedFile: File | null = null;
  loading: boolean = true;
  showHistory: boolean = false
  isConsolePage: boolean = false;

  constructor(private router: Router, private vm: TaskViewModel,
    private quickAddService: QuickAddService, private cvm: ConsoleViewModel,
    private activeRouter: ActivatedRoute, private modal: NzModalService,
    private consoleTabService: ConsoleTabService,
    private message: NzMessageService,
    private quilservice:QuillCustomServices
  ) {
    this.loggedInUser = AppCommon.getloggedInObject().user;
    this.vm.taskStatusList.pipe(takeUntil(this.destroy$)).subscribe(data => { this.listOfTaskStatus = data.results });
    this.vm.priorityList.pipe(takeUntil(this.destroy$)).subscribe(data => { this.listOfPriority = data.results });
    this.vm.taskComment.pipe(takeUntil(this.destroy$)).subscribe(data => {
      const results = data?.results || [];
      this.taskCommentList = [...results].sort((a: any, b: any) => {
        const t1 = new Date(a?.created_at || 0).getTime();
        const t2 = new Date(b?.created_at || 0).getTime();
        return t1 - t2;
      });
      this.scrollCommentsToBottom();
    });
    this.cvm.taskData.pipe(takeUntil(this.destroy$)).subscribe(data => this.tabData = data);
    this.quickAddService.refreshData.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data) {
        this.getData();
      }
    })
    this.quillConfig = this.quilservice.QuillConfigDefault
    this.vm.userList.pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      this.quilservice.setMentions(data)
    })
  }


  ngOnInit(): void {
    if (this.router.url.includes('/app/console')) {
      this.isConsolePage = true;
    }

    if (this.router.url.includes('/app/tasks')) {
      const pageID = Number(this.activeRouter.snapshot.paramMap.get('id'));
      this.tabData = { id: pageID, name: `task-details-${pageID}` }
    }

    this.vm.consoleTaskTabComponent = this;
    this.vm.taskData.subscribe(this.taskDataModel);
    this.getData();
    this.vm.getUserList(1,1000);
    this.vm.getPriorityList(this.page, this.page_size);
    this.vm.getTaskStatusList(this.page, this.page_size);
    this.vm.getTaskCommentList(this.tabData.id);
  }

  getData() {
    this.loading = true;
    this.vm.getTaskById(this.tabData.id, 'app-console-task-tab');
  }


  taskDataReceived() {
    this.loading = false;
    this.taskData = this.taskDataModel.value;
    // Debug: log when API data is assigned to component state
    this.is_reviewed = this.taskData.is_reviewed
    if (this.isConsolePage) {
      this.tabData.name = this.taskData.name;
    }
    // Precompute display fields for assignees (initials, image validity)
    this.prepareAssignedUsers();
  }


  taskDataReceivedError() {
    this.loading = false;
    if (!this.tabData.name.startsWith('task-details')) {
      this.modal.confirm({
        nzTitle: 'The task is not available or deleted.',
        nzContent: '<b style="color: red;">Do you want to remove it?</b>',
        nzOkText: 'Yes',
        nzOkType: 'primary',
        nzOkDanger: true,
        nzOnOk: () => this.consoleTabService.removeConsoleTabById(this.tabData.id),
        nzCancelText: 'No',
        nzOnCancel: () => console.log('Cancel')
      });
    }
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['tabData']?.currentValue) {
      // console.log('Input changed:', changes['tabData'].currentValue);
      // You can react to the new value here
      //  this.getData();
      this.loading = false
      this.tabData && this.vm.getTaskCommentList(this.tabData.id);
      this.tabData && this.vm.getPriorityList(this.page, this.page_size);
      this.tabData && this.vm.getTaskStatusList(this.page, this.page_size);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }


  ngAfterViewInit(): void {
    this.scrollCommentsToBottom();
  }

  private scrollCommentsToBottom(): void {
    setTimeout(() => {
      const container = this.commentsContainer?.nativeElement;
      if (!container) return;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          container.scrollTop = container.scrollHeight;
        });
      });
    }, 0);
  }

  getTaskPriorityName(id: number) {
    return id ? this.listOfPriority?.filter(e => e.id == id)[0]?.name : ''
  }

  showHisory() {
    this.showHistory = true
  }
  setIsVisible() {
    this.showHistory = false
  }

  postComment() {
    if (!this.newComment.trim()) return;

    if (this.editingComment) {
      this.saveEditComment();
      return;
    }

    let data = {
      comment: this.newComment,
      created_by: this.loggedInUser.id,
      created_at: new Date().toISOString(),
      created_by_name: this.loggedInUser.first_name,
      source_task: this.tabData.id
    }
    this.vm.createTaskComment(data)
    this.newComment = ''
    this.scrollCommentsToBottom();
  }

  taskCommentadded() {
    this.vm.getTaskCommentList(this.tabData.id);
  }

  // ── Comment edit ─────────────────────────────────────────────
  editingComment: any = null;

  canEditComment(comment: any): boolean {
    if (comment.created_by !== this.loggedInUser?.id) return false;
    return (Date.now() - new Date(comment.created_at).getTime()) < 5 * 60 * 1000;
  }

  startEditComment(comment: any): void {
    this.editingComment = comment;
    this.newComment = comment.comment;
    setTimeout(() => {
      const container = this.commentsContainer?.nativeElement;
      if (container) container.scrollTop = container.scrollHeight;
    }, 50);
  }

  cancelEditComment(): void {
    this.editingComment = null;
    this.newComment = '';
  }

  saveEditComment(): void {
    if (!this.newComment?.trim()) return;
    this.vm.updateTaskComment({ id: this.editingComment.id, comment: this.newComment });
    this.editingComment = null;
    this.newComment = '';
  }

  editTask(data: any) {
    this.quickAddService.openQuickUpdate('task', data)
  }



  reviewTask(){
    // this.is_reviewed = !this.is_reviewed;
    let d={is_reviewed:this.is_reviewed,modified_by:this.loggedInUser.id,modified_at:new Date().toISOString}
    this.vm.updateTask(d, this.tabData.id, 'task-details')
  }

  deleteTask(data: any) {
    if (!data) {
      return
    }
    this.vm.deleteTaskById(data.id);
  }

  taskDeleted() {
    // Show a toaster to confirm deletion success
    this.message.success('Task deleted successfully', { nzDuration: 1000 });
    if (this.tabData.name.startsWith('task-details')) {
      this.router.navigate(['/app/tasks'])
    } else {
      this.consoleTabService.removeConsoleTabById(this.tabData.id);
    }
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
    }
  }



  formatIdToFourDigits(id: number): string {
    return id ? 'TS' + id.toString().padStart(4, '0') : '';
  }


  getBase64Image(data: string) {
    if (!data) {
      return undefined;
    }
    return "data:image/png;base64," + data;
  }

  private pickValidBase64(val?: string): string | undefined {
    if (!val || typeof val !== 'string') return undefined;
    const trimmed = val.trim();
    return trimmed.length > 20 ? trimmed : undefined;
  }

  getValidAvatarSrc(user: any): string | undefined {
    const best = this.pickValidBase64(user?.photo) ?? this.pickValidBase64(user?.image);
    return best ? this.getBase64Image(best) : undefined;
  }

  private prepareAssignedUsers() {
    const users = this.taskData?.assigned_to_details;
    if (!Array.isArray(users)) return;
    users.forEach(u => {
      const name = u?.name || u?.user_name || (u?.email ? u.email.split('@')[0] : '');
      const init = this.getUserInitials({ name });
      u.initials = init;
      u.initialsFirst = init?.charAt(0) || '';
      u.initialsLast = init?.charAt(1) || '';
      u.avatarSrc = this.getValidAvatarSrc(u);
    });
  }


  isCurrentUser(created_by: number) {
    return this.loggedInUser.id == created_by;
  }

  getPriorityColor(priority: number): string {
    switch (priority) {
      case 3: return 'red';
      case 2: return 'orange';
      case 1: return 'blue';
      default: return 'default';
    }
  }

  getStatusColor(status: number) {
    // console.log(status , this.listOfTaskStatus , this.listOfTaskStatus.filter( e => e.id == status)[0].hexcolor)
    if (this.listOfTaskStatus) {
      return status ? this.listOfTaskStatus.filter(e => e.id == status)[0].hexcolor : 'default';
    }

  }

  // Two-letter initials from user display name (First + Last); if single token, first two letters
  getUserInitials(user: any): string {



    const name = user?.name || user?.user_name || (user?.email ? user.email.split('@')[0] : '');
    if (!name || typeof name !== 'string') return '';
    // Split on spaces first, otherwise try common separators (., _, -) for email/usernames
    let parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 1) {
      parts = name.trim().split(/[._-]+/).filter(Boolean);
    }
    if (parts.length === 0) return '';
    let initials = '';
    if (parts.length > 1) {
      initials = (parts[0]?.charAt(0) || '') + (parts[parts.length - 1]?.charAt(0) || '');
    } else {
      const token = parts[0] || '';
      // Remove non-letters to avoid symbols
      const clean = token.replace(/[^A-Za-z]/g, '');
      initials = (clean.charAt(0) || token.charAt(0) || '') + (clean.charAt(1) || token.charAt(1) || '');
    }
    return initials.toUpperCase();
  }

}
